import React from 'react';

import RequestQueueTablePage from './RequestQueueTablePage';
import { reserveFallbackQueue } from './requestQueueFallbacks';


export default function ReservePage() {
    return (
        <RequestQueueTablePage
            title="Резерв"
            queueName="reserve"
            summaryLabel="Заявок в резерве"
            emptyQueueText="В резерве пока нет заявок."
            warningText="Не удалось загрузить резерв. Показан локальный пример."
            fallbackQueue={reserveFallbackQueue}
            detailPathPrefix="/app/reserve"
        />
    );
}
